import _ from 'lodash';
import axiosCall, { getConfig } from 'src/services/axiosHelper';

export async function getBookReference(option: 'SEARCH' | 'LIST'): Promise<TitledObject[]> {
  const data =  await axiosCall<TitledObject[]>({
    method: 'get',
    url: `/grouper/${encodeURIComponent(getConfig().facilityCode)}/reference/book?option=${encodeURIComponent(_.defaultTo(option, ''))}`,
  }, []);
  return data;
}

export async function getBookReferenceYears(bookId: string): Promise<number[]> {
  const data =  await axiosCall<number[]>({
    method: 'get',
    url: `/grouper/${encodeURIComponent(getConfig().facilityCode)}/reference/book/${encodeURIComponent(bookId)}/year/`,
  }, []);

  return data;
}

export async function getBookReferenceYearIssue(book: string, year: number): Promise<TitledObject[]> {
  const data =  await axiosCall<TitledObject[]>({
    method: 'get',
    url: `/grouper/${encodeURIComponent(getConfig().facilityCode)}/reference/book/${encodeURIComponent(book)}/year/${encodeURIComponent(year)}/issue`,
  }, []);

  return data;
}

export async function getReferencesArticle(articleId: string): Promise<string> {
  const data =  await axiosCall<string>({
    method: 'get',
    url: `/grouper/${encodeURIComponent(getConfig().facilityCode)}/reference/article/${encodeURIComponent(articleId)}?partial=true`,
  }, '');
  return data;
}

export async function getReferencesArticles(issueId: number): Promise<TitledObject[]> {
  const data =  await axiosCall<GetReferencesArticlesResponse>({
    method: 'get',
    url: `/grouper/reference/issue/${encodeURIComponent(issueId)}/article/${encodeURIComponent(getConfig().facilityCode)}`,
  }, { Articles: [] });

  return data.Articles.map(article => {
    return {id: article.ID, title: article.ArticleTitle};
  });
}

export async function getReferenceBookTermSearch(book: string, term: string): Promise<TitledObject[]> {
  const data =  await axiosCall<GetReferenceBookTermSearchResponse[]>({
    method: 'get',
    url: `/grouper/${encodeURIComponent(getConfig().facilityCode)}/reference/book/${encodeURIComponent(book)}/${encodeURIComponent(term)}`,
  }, []);

  const mappedResults: TitledObject[] = _(data).map(
    ({ articles, name }) => articles.map(
      ({article_id, article_title}) => ({
        id: article_id,
        title: article_title,
        best: name === 'Best',
      })
    )
  ).flatten().value();
  return mappedResults;
}

export type TitledObject = {
  id: string,
  title: string
  type?: 'book'|'year'|'issue'|'article'
  lazy?: boolean;
  selectable?: boolean;
  best?: boolean;
  expanded?: boolean;
}

export interface GetReferencesArticlesResponse {
  Articles: {ID: string, ArticleTitle: string}[]
}

export interface GetReferenceBookTermSearchResponse {
  name: string,
  articles: GetArticleResponse[]
}

export interface GetArticleResponse {
  details: ArtifactDetails,
  article_id: string,
  article_title: string
}

export interface ArtifactDetails {
  issueTitle: string,
  issueYear: string,
  issueMonth: string
}
